var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3713 25.5144L20.3712 25.5139C20.3546 25.4416 20.3356 25.3635 20.3152 25.2796C20.1656 24.6634 19.9401 23.7351 20.0193 22.5149C20.1098 21.1218 20.5851 19.4072 21.8442 17.2265C23.4153 14.5051 22.7779 11.2187 20.4874 9.1754L19.8802 8.63378L20.287 7.92917L20.7755 7.08317C20.9138 6.84362 20.8313 6.53809 20.5933 6.40063C20.3552 6.26318 20.0494 6.34456 19.9111 6.58412L19.4226 7.43011L19.0158 8.13473L18.2432 7.87973C15.3284 6.91774 12.1635 8.00888 10.5924 10.7302C9.33333 12.911 8.08606 14.1799 6.92491 14.9548C5.90776 15.6336 4.99111 15.9024 4.38261 16.0809C4.29976 16.1052 4.22262 16.1278 4.15171 16.1496C4.00839 16.1936 3.92217 16.2745 3.86939 16.3673C3.86937 16.3673 3.86936 16.3673 3.86935 16.3673M20.3713 25.5144L3.00003 15.8731L3.86935 16.3673M20.3713 25.5144C20.4047 25.6594 20.3781 25.7748 20.3238 25.8673L20.3235 25.8678C20.1827 26.1083 19.8831 26.1979 19.6334 26.0537L4.05312 17.0584C3.80385 16.9145 3.73117 16.6105 3.86935 16.3673M20.3713 25.5144L3.86935 16.3673M11.5925 25.4527C10.9942 25.7977 10.2336 25.8229 9.59327 25.4532C8.95298 25.0835 8.59446 24.4123 8.59403 23.7216L11.5925 25.4527Z",
    stroke: "#DEEBFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationHover);
export default __webpack_public_path__ + "static/media/notification-hover.c026af5fbe0b22c8e00ab45c21163511.svg";
export { ForwardRef as ReactComponent };